export default __webpack_public_path__ + "static/media/Technology-hover.4bd4283f.svg";